import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesRemessa.vue?vue&type=template&id=11acddec"
import script from "./LicitacaoAtualizacaoAcoesRemessa.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesRemessa.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoAtualizacaoAcoesRemessa.vue?vue&type=style&index=0&id=11acddec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports